<dl *ngIf="items" [class]="classNames">
    <ng-container *ngFor="let item of items">
        <dt class="sh-inline-description-list__term" [title]="item.icon?.iconOnly ? item.term : ''">
            <svg
                *ngIf="item.icon"
                sh-icon
                [name]="item.icon?.name"
                [size]="item.icon?.size || defaultIconSize"
                class="sh-inline-description-list__term__icon"
                aria-hidden="true"
            ></svg>
            <span [ngClass]="{'sh-visually-hidden': item.icon?.iconOnly}">{{item.term}}</span>
        </dt>
        <dd
            class="sh-inline-description-list__details"
            [ngClass]="{
                '-sh-diminish': item.icon?.iconOnly || item.navigationLink || inlineDescriptionListAsDetailsGuard(item) || diminish,
                '-sh-full-width': fullWidth
            }"
            [title]="inlineDescriptionListAsDetailsGuard(item) ? '' : item.details"
        >
            <ng-container
                *ngIf="baseInlineDescriptionListItemGuard(item) &&
                !navigationLinkInlineDescriptionListItemGuard(item) &&
                !eventListenerInlineDescriptionListItemGuard(item)"
            >
                <ng-container *ngTemplateOutlet="itemDetailsDefault; context: {item: item}"></ng-container>
            </ng-container>
            <ng-container *ngIf="navigationLinkInlineDescriptionListItemGuard(item)">
                <ng-container *ngTemplateOutlet="itemDetailsWithLink; context: {item: item}"></ng-container>
            </ng-container>
            <ng-container *ngIf="eventListenerInlineDescriptionListItemGuard(item)">
                <ng-container *ngTemplateOutlet="itemDetailsWithEventListener; context: {item: item}"></ng-container>
            </ng-container>
        </dd>
    </ng-container>
</dl>

<ng-template #itemDetailsDefault let-item="item">
    <ng-container *ngTemplateOutlet="itemDetails; context: {item: item}"></ng-container>
</ng-template>

<ng-template #itemDetailsWithLink let-item="item">
    <a [shNavigationLink]="item.navigationLink" class="sh-link" [title]="item.details">
        <ng-container *ngTemplateOutlet="itemDetails; context: {item: item}"></ng-container>
    </a>
</ng-template>

<ng-template #itemDetailsWithEventListener let-item="item">
    <button type="button" class="sh-link" (click)="handleClick($event, item)" [title]="item.details">
        <ng-container *ngTemplateOutlet="itemDetails; context: {item: item}"></ng-container>
    </button>
</ng-template>

<ng-template #itemDetails let-item="item">
    <ng-container *ngIf="inlineDescriptionListAsDetailsGuard(item); else detailsAsString">
        <sh-inline-description-list [items]="item.details" [direction]="direction" [fontSize]="fontSize" [diminish]="true"></sh-inline-description-list>
    </ng-container>
    <ng-template #detailsAsString>{{ item.details }}</ng-template>
</ng-template>
